/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { TimeZonePicker } from '@neo4j-ndl/react';
import { useState } from 'react';

const Component = () => {
  const [selectedTimeZone, setSelectedTimeZone] = useState<string>('UTC');

  const handleTimeZoneChange = (timezone: string) => {
    setSelectedTimeZone(timezone);
  };

  return (
    <div>
      <TimeZonePicker
        label="Select UTC Timezone"
        value={selectedTimeZone}
        onChange={handleTimeZoneChange}
        mode="utc"
        htmlAttributes={{ id: 'time-zone-input' }}
      />
      <div style={{ marginTop: '1rem' }}>
        <p>
          <strong>Selected Timezone:</strong> {selectedTimeZone}
        </p>
        <div
          style={{
            backgroundColor: '#f5f5f5',
            borderRadius: '4px',

            marginTop: '1rem',
            padding: '1rem',
          }}
        >
          <p>
            <strong>Features:</strong>
          </p>
          <ul
            style={{
              fontSize: '0.9em',
              margin: 0,
              paddingLeft: '1.5rem',
            }}
          >
            <li>Select from common UTC offsets (UTC-12 to UTC+14)</li>
            <li>Includes fractional offsets (UTC+5:30, UTC+9:30, etc.)</li>
            <li>Type custom offsets: UTC+1:05, UTC-3:45, etc.</li>
            <li>Ideal for database entries and technical applications</li>
          </ul>
          <p
            style={{
              color: '#999',
              fontSize: '0.85em',
              marginBottom: 0,
              marginTop: '0.5rem',
            }}
          >
            Try typing: UTC+5:30, UTC-7:15, or UTC+12:45
          </p>
        </div>
      </div>
    </div>
  );
};

export default Component;
